/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_itemSearch$ref = any;
export type SbSharedRefineMenuFilterOrigin_itemSearch$ref = any;
export type SbSharedRefineMenuFilterOrigin_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterOrigin_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterOrigin_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'df1a710fcc76821d0e1411806d6d7fc1';
export default node;
